// USA
export const locale = {
	lang: 'en',
	data: {
		TRANSLATOR: {
			SELECT: 'Select your language',
			NAME: 'name_en',
		},
		MENU: {
			NEW: 'new',
			ACTIONS: 'Actions',
			CREATE_POST: 'Create New Post',
			PAGES: 'Pages',
			FEATURES: 'Features',
			APPS: 'Apps',
			DASHBOARD: 'Dashboard',
		},
		DASHBOARD:{
			TOTAL_AREAS:'Total Areas',
			TOTAL_COMPANIES:'Total Companies',
			TOTAL_CARS:'Total Cars',
			TOTAL_AMOUNT:'Total Amount',
			MOBILE:'Mobile',
			FULL_NAME:'Full name',
			COMPANY_NAME:'Company name',
			RECENT_DRIVERS:'Recent Drivers',
			RECENT_CARS:'Recent cars',
			CAR_PLATE:'Car plate',
			COLOR_NAME:'Color',
			COLOR_NAME_EN:'name_en',
		   },
		USER_PROFILE:{
			HI:'Hi,'
		},
		AUTH: {
			GENERAL: {
				OR: 'Or',
				SUBMIT_BUTTON: 'Submit',
				NO_ACCOUNT: 'Don\'t have an account?',
				SIGNUP_BUTTON: 'Sign Up',
				FORGOT_BUTTON: 'Forgot Password',
				BACK_BUTTON: 'Back',
				PRIVACY: 'Privacy',
				LEGAL: 'Legal',
				CONTACT: 'Contact',
				SIGNOUT: 'Sign out',
				RIGHTS: 'All rights are reserved 2020'
			},
			LOGIN: {
				TITLE: 'Login Account',
				BUTTON: 'Sign In',
				HELLO:'HELLO',
				LOGIN_DATA:'Fill your Login information',
			},
			FORGOT: {
				TITLE: 'Forgotten Password?',
				DESC: 'Enter your email to reset your password',
				SUCCESS: 'Your account has been successfully reset.'
			},
			REGISTER: {
				TITLE: 'Sign Up',
				DESC: 'Enter your details to create your account',
				SUCCESS: 'Your account has been successfuly registered.'
			},
			INPUT: {
				EMAIL: 'Email',
				MOBILE: 'Mobile',
				EMPLOYEE_NUMBER: 'Employee Number',
				FULLNAME: 'Fullname',
				PASSWORD: 'Password',
				CONFIRM_PASSWORD: 'Confirm Password',
				USERNAME: 'Username',
				LOGIN_BY:'Login using:'
			},
			VALIDATION: {
				INVALID: '{{name}} is not valid',
				REQUIRED: '{{name}} is required',
				MIN_LENGTH: '{{name}} minimum length is {{min}}',
				AGREEMENT_REQUIRED: 'Accepting terms & conditions are required',
				NOT_FOUND: 'The requested {{name}} is not found',
				INVALID_LOGIN: 'The login detail is incorrect',
				REQUIRED_FIELD: 'Required field',
				MIN_LENGTH_FIELD: 'Minimum field length:',
				MAX_LENGTH_FIELD: 'Maximum field length:',
				INVALID_FIELD: 'Input is not valid',
			}
		},
		ECOMMERCE: {
			COMMON: {
				SELECTED_RECORDS_COUNT: 'Selected records count: ',
				ALL: 'All',
				SUSPENDED: 'Suspended',
				ACTIVE: 'Active',
				FILTER: 'Filter',
				BY_STATUS: 'by Status',
				BY_TYPE: 'by Type',
				BUSINESS: 'Business',
				INDIVIDUAL: 'Individual',
				SEARCH: 'Search',
				IN_ALL_FIELDS: 'in all fields'
			},
			ECOMMERCE: 'eCommerce',
			CUSTOMERS: {
				CUSTOMERS: 'Customers',
				CUSTOMERS_LIST: 'Customers list',
				NEW_CUSTOMER: 'New Customer',
				DELETE_CUSTOMER_SIMPLE: {
					TITLE: 'Customer Delete',
					DESCRIPTION: 'Are you sure to permanently delete this customer?',
					WAIT_DESCRIPTION: 'Customer is deleting...',
					MESSAGE: 'Customer has been deleted'
				},
				DELETE_CUSTOMER_MULTY: {
					TITLE: 'Customers Delete',
					DESCRIPTION: 'Are you sure to permanently delete selected customers?',
					WAIT_DESCRIPTION: 'Customers are deleting...',
					MESSAGE: 'Selected customers have been deleted'
				},
				UPDATE_STATUS: {
					TITLE: 'Status has been updated for selected customers',
					MESSAGE: 'Selected customers status have successfully been updated'
				},
				EDIT: {
					UPDATE_MESSAGE: 'Customer has been updated',
					ADD_MESSAGE: 'Customer has been created'
				}
			}
		},
		COMPANY_MANAGEMENT:{
        	COMPANIES:{
				TITLE: 'Companies',
				COMPANY_LIST:{
					TITLE: 'Company List',
					ADD_NEW_COMPANY: 'Add New Company',
					COMPANY_INFORMATION: 'Company Information',
					NEED_TO_ADD_ONE_AREA: 'You need to add at least one area',
					TABLE: {
						ACCEPT_BALANCE_PAYMENT: 'Accept Balance Payment',
						COMPANY_NAME: 'Company Name',
						AREA: 'Area',
						ON: 'ON',
						OFF: 'OFF',
						TICKET_FEES: 'Ticket Fees'
					}
			},
			COMPANY_CARS:{
				TITLE: 'Company Cars',
				ADD_NEW_CAR: 'Add new company car',
				COMPANY_CAR_INFORMATION: 'Company car information',
				EDIT_COMPANY_CAR: 'Edit company car',
				SEARCH_COMPANY_CAR: 'Search company cars',
				SELECT_COMPANY: 'Select compnay',
				TABLE: {
					NAME_EN: 'Name in English',
					NAME_AR: 'Name in Arabic',
					PRICE_PER_KM: 'Price/KM',
					COMPANY: 'Company',
					SELECT_COMPANY: 'Select company',
					COMPANY_NAME: 'Company Name',
				}
			},
			CARS:{
				TITLE: 'Cars',
				CARS: 'Cars',
				ADD_NEW_CAR: 'Add New Car',
				CAR_INFORMATION: 'Car Information',
				EDIT_COMPANY_CAR: 'Edit Car',
				SEARCH_COMPANY_CAR: 'Search Cars',
				DRIVER_LIST: 'Driver List',
				SELECT_COMPANY: 'Select Compnay',
				TABLE: {
					PLATE_NUMBER: 'Plate Number',
					CAR_TYPE: 'Car Type',
					CAR_MODEL: 'Car Model',
					CAR_COLOR: 'Car Color',
					CAR_NAME: 'Car Name',
					NAME_EN: 'Car name in English',
					NAME_AR: 'Car name in Arabic',
					COMPANY: 'Company',
					SELECT_COMPANY: 'Select company',
					COMPANY_NAME: 'Company Name',
					MANFACTURER_ID: 'Manufacturer Name',
					MODEL_YEAR: 'Model Year'
				}
			},
			DRIVERS:{
				DRIVER_LIST: 'Drivers list',
				TITLE: 'Drivers',
				ADD_NEW_DRIVER: 'Add New Driver',
				DRIVER_INFORMATION: 'Driver Information',
				EDIT_DRIVER: 'Edit Driver',
				SEARCH_COMPANY_DRIVER: 'Search Drivers',
				SELECT_COMPANY: 'Select company',
				SELECT_CAR: 'Select car',
				CAR_LIST: 'Cars List',
				DRIVER_CARS: 'Driver Cars',
				TABLE: {
					CAR_TYPE: 'Car Type',
					CAR_MODEL: 'Car Model',
					COMPANY: 'Company',
					COMPANY_NAME: 'Company Name',
					MOBILE: 'Mobile',
					NAME: 'Full Name',
					AREA: 'Area',
					PASSWORD: 'Password'
				}
			}
		},
		COMPANY_BALANCE: {
			TITLE: 'Company Balances',
			COMPANY_BALANCE_LIST: {
				TITLE: 'Company Balance List',
				ADD_NEW_COMPANY_BALANCE: 'Add Balance',
				COMPANY_TOTAL_BALANCE: 'Comapny Total Balance',
				TABLE: {
					AMOUNT: 'Amount',
					REFERENCE_ID: 'Reference ID'
				}
			}
		},
		PLACES:{
			TITLE: 'Places',
			PLACE_LIST:{
				TITLE: 'Places List',
				CAR_TYPE_PRICE: 'Car Types Price',
				TABLE:{
					NAME: 'Name',
					NAME_AR: 'Name in Arabic',
					NAME_EN: 'Name in English',
					LOCATION: 'Location',
					PLACE_TYPE: 'Place Type',
					ADDRESS_AR: 'Address in Arabic',
					ADDRESS_EN: 'Address in Enlgish',
				}
			}
		},
		},
		AREA_MANAGEMENT:{
			AREAS:{
				TITLE:'Areas',
				AREA_LIST:{
					TITLE: 'Area List',
					TABLE:{
						AREA_NAME: 'Name',
						LOCATION: 'Location',
						AREA_NAME_AR: 'Name in Arabic',
						AREA_NAME_EN: 'Name in English',
						AREA_ID: 'ID'
					}
				}
			}
		},
		LOOKUP_MANAGEMENT:{
			TITLE:'Lookup Management',
			COLOR:{
				TITLE: 'Car colors',
				COLOR_LIST:{
					TITLE: 'Car Colors List',
					TABLE:{
						COLOR_NAME: 'Name',
						COLOR_NAME_AR: 'Name in Arabic',
						COLOR_NAME_EN: 'Name in English'
					}
				}
			},
			PLACE_TYPES:{
				TITLE: 'Place Types',
				PLACE_TYPES_LIST:{
					TITLE: 'Place Types List',
					TABLE:{
						NAME: 'Name',
						NAME_AR: 'Name in Arabic',
						NAME_EN: 'Name in English'
					}
				}
			},
			MODEL:{
				TITLE: 'Car Models',
				MODEL_LIST:{
					TITLE: 'Car Models List',
					TABLE:{
						MODEL_NAME: 'Name',
						MANUFACTURER_NAME: 'Manufacturer Name',
						MODEL_NAME_AR: 'Name in Arabic',
						MODEL_NAME_EN: 'Name in English'
					}
				}
			},
			MANUFACTURER:{
				TITLE: 'Car Manufacturers',
				MANUFACTURER_LIST:{
					TITLE: 'Car Manufacturers List',
					TABLE:{
						MANUFACTURER_NAME: 'Name',
						MANUFACTURER_NAME_AR: 'Name in Arabic',
						MANUFACTURER_NAME_EN: 'Name in English'
					}
				}
			}
		},
		QUEUE_MANAGEMENT:{
			BARRIER:{
				TITLE:'Barriers',
				BARRIER_LIST:{
					TITLE: 'Barrier List',
					TABLE:{
						BARRIER_NAME: 'Name',
						NAME_AR: 'Name in Arabic',
						NAME_EN: 'Name in English',
						BARRIER_ID: 'ID'
					}
				}
			},
			QUEUES:{
				TITLE: 'Queues',
				QUEUE_LIST:{
					TITLE: 'Queue List',
					TABLE:{
						QUEUE_NAME: 'Queue Name',
						LOCATION: 'Location',
						AREA_NAME: 'Area Name',
						COMPANY_NAME: 'Company Name',
						COMPANY_NAME_SELECT: 'Select another company',
						CAPACITY: 'Capacity',
						REQUEST_MAX_DURATION: 'Request max duration to arrive to the gate (minutes)',
						ENTER_BARRIER_ID: 'Entry barrier',
						SELECT_ENTER_BARRIER_ID: 'Select entry barrier',
						EXIT_BARRIER_ID: 'Exit barrier',
						SELECT_EXIT_BARRIER_ID: 'Select exit barrier',
						SECOND_EXIT_BARRIER_ID: 'Second exit barrier',
						SELECT_SECOND_EXIT_BARRIER_ID: 'Select second exit barrier',
						CAPACITY_COMPANY_CAR_TYPES: 'Capacity of comapny car types',
					}
				}
			},
			REQUESTS:{
				TITLE: 'Car Requests',
				REQUEST_LIST:{
					TITLE: 'Car Requests List',
					SELECT_STATUS: 'Filter Statuses',
					SEARCH_MOBILE: 'Search by mobile',
					CREATE: 'Create Request',
					COMPANY: 'Company',
					CAR_TYPE: 'Car type',
					MANUAL_REJECTED_ONLY: 'Manual rejected only',
					TABLE:{
						QUEUE_NAME_FROM: 'From Queue',
						QUEUE_NAME_TO: 'To Queue',
						AREA_NAME: 'Area Name',
						STATUS_NAME: 'Status',
						DRIVER_NAME: 'Drvier Name',
						CAR: 'Car Name',
						VIEWED: 'Viewed',
						ACCEPTED: 'Accepted',
						REJECTED: 'Rejected',
						TIMEOUT: 'Timeout',
						MOBILE: 'Mobile',
						DETAILS: 'Details',
						REQUEST_DETAILS: 'Request Details',
						DIFF_TIME: 'Time Diff',
						CAR_PLATE: 'Car plate',
					}
				}
			},
			LIVE_QUEUES:{
				TITLE: 'Live Queues',
				LIVE_QUEUES_LIST:{
					TITLE: 'Live Queues List',
					TABLE:{
					}
				}
			}
		},
		SHIFT_MANAGEMENT:{
			SHIFTS:{
				TITLE: 'Shifts',
				SHIFT_LIST:{
					TITLE: 'Shift List',
					SELECT_CASHIER: 'Select Cashier',
					CASHIER: 'Cashier Name',
					ALL_CASHIERS: 'All Cashiers',
					TABLE:{
						START_DATE: 'Start Date',
						END_DATE: 'End Date',
						SHIFT_STATUS: 'Shift Status',
						CLOSE_AMOUNT: 'Close Amount',
						DIFFERENCE: 'Difference',
						COMPANY_AMOUNT: 'Company Pay',
						DRIVER_AMOUNT: 'Driver Pay',
						TOTAL: 'Total',
						AMOUNT: 'Cash Pay',
						CLOSED: 'Closed',
						OPENED: 'Open',
					}
				},
				PAYMENT_LIST:{
					TITLE: 'Payments',
					CANCELLED_FILTER_LABEL: 'Payment status',
					CANCELLED_FILTER_ALL: 'All',
					CANCELLED_FILTER_CANCELLED: 'Cancelled only',
					CANCELLED_FILTER_NOT_CANCELLED: 'Not cancelled',
					TABLE:{
					 PAYMENT_ID:'Payment ID',
					 REQUEST_ID:'Request ID',
					 AREA_NAME:'Area',
					 COMPANY_NAME:'Company',
					 CASHIER_NAME:'Cashier',
					 DRIVER_NAME:'Driver',
					 CAR_NAME:'Car',
					 AMOUNT:'Amount',
					 PAYMENT_METHOD:'Payment method',
					 COMPANY_PAY:'Company pay',
					 MANUAL_PAY:'Cash Pay',
					 DRIVER_PAY:'Driver balance pay',
					 CREATED_AT:'Date'
					}
				}
			}
		},
		LIVE_QUEUE_STATISTICS:{
			TITLE: 'Live queue statistics',
			COUNT_TITLE: 'Cars count in live queues',
			CAR_COUNT_BY_AREA_TITLE: 'Area Entry',
			ACCEPTED_REQUESTS_TITLE: 'Accepted Requests',
			DRIVERS_REQUESTS_REJECTED_TITLE: 'Drivers list of rejected Requests',
			LIVE_QUEUE_ACTIONS_TITLE: 'Enter / Exit',
			PAYMENT_TITLE: 'Payments',
		},
		COMMON:{
			ADD: 'Add',
			NEW: 'New',
			EDIT: 'Edit',
			DELETE: 'Delete',
			PREVIOUS: 'Previous',
			BACK: 'Back',
			SAVE: 'Save',
			SEND: 'Send',
			SAVE_EXIT: 'Save & Exit',
			SAVE_DUBLICATE: 'Save & Dublicate',
			RESET:'Reset',
			OTHER:'other',
			OTHERS:'others',
			SUCCESS: 'Operation completed successfuly!',
			DELET_CONFIRM: 'Are you sure?',
			CANCEL: 'Cancel',
			CLOSE: 'Close',
			CONFIRM: 'Confirm',
			NO_RECORD_FOUND: 'No records found',
			NEXT: 'Next',
			SEARCH: 'Search',
			IN_ALL_FIELDS: 'in all fields',
			PLEASE_WAIT:'Please wait....',
			LOADING: 'Loading ...',
			FORM_ERROR: 'Oh snap! Change a few things up and try submitting again.',
			ID: 'ID',
			SELECT:'Select',
			SELECT_ALL:'Select all',
			UN_SELECT_ALL:'Unselect all',
			CREATED_AT:"Created at",
			SHIFT_NOT_CLOSED:"Not closed",
			TOTAL:"Total",
			DATE_FROM: 'From Date',
			DATE_TO: 'To Date',
			DISABLE: 'Disable',
			ENABLE: 'Enable',
			ALL: 'All',
			ACTION: 'Action',
			ENTER: 'Enter',
			EXIT: 'Exit',
			NA: 'N/A',
			PROCESSING: 'Processing...'
		},
		USER_MANAGEMENT:{
			USER_LIST_TITLE:'Users List',
			USER_EDIT_TITLE:'Edit User',
			USER_CREATE_TITLE:'Create user',
			TITLE: 'User Management',
			FULL_NAME: 'Full Name',
			MOBILE: 'Mobile',
			EMPLOYEE_NUMBER: 'Employee Number',
			ROLE: 'Role',
			DRIVER_COMPANY: 'Driver Company',
			CASHIER_AREA: 'Cashier Area',
			BLOCKED: 'Blocked',
			BLOCK_REASON: 'Block Reason',
			ACTIONS: 'Actions',
			PASSWORD: 'Password',
			EMPLOYEE_NUMBER_OR_MOBILE: 'Please, type employee number or mobile',
		},
		REPORTS:{
			TITLE:'Reports',
            RECENT_CARS:{
				TITLE:'Recent Cars',
			},
			RECENT_DRIVERS:{
				TITLE:'Recent Drivers',
			}
		},
		MATTABLE:{
			FILTER: 'Filter',
			FILTER_EXAMPLE: 'Ex. ium',
		},
		CASHIER:{
			TITLE:'Cashair',
			SIGNOUT:{
				AMOUNT: 'Amount',
				AMOUNT_DESC: 'Please Enter the Total Amount you Earned in the Day'
			},
			WAITING:{
				REFRESH:'Refresh',
				NO_CARS_AT_MOMENT:'No cars at the moment',
				PAY_MANUALLY:'Pay manually',
				AUTO_REFRESH_ENABLED:'Auto refrsh enabled',
				AUTO_REFRESH_DESABLED:'Auto refrsh disabled',
			},
			MANUALLY:{
				DRIVER_INFORMATION:'Driver\'s Information',
				MOBILE_PHONE:'Mobile number',
				MOBILE_PHONE_HINT:"Mobile number has to start with number 5 and consists of 9 digits",
				NEXT:'Next',
				SEND:'Send',
			},
			DRIVER:{
				DRIVER_INFORMATION:'Driver\'s Information',
				MOBILE_PHONE:'Mobile number',
				FULL_NAME:'Full Name',
				NAME:'Driver Name',
				COMPANY_INFORMATION:'Company\'s Information',
				COMPANY_NAME:'Comany\'s Name',
				COMPANY_BALANCE:'Company\'s Balance',
				CAR_INFORMATION:'Car Information',
				SELECT_CAR:'Select car',
				PLATE_NUMBER:'Plate Number',
				CAR_TYPE:'Car Type',
				CAR_NAME:'Car Name',
				BACK:'Back',
				PAY_CASH:'Pay Cash',
				COMPANY_PAY:'Company Pay',
				PAY_DRIVER_BALANCE:'Pay from driver balance',
				AMOUNT:'Amount',
				CAR_MODEL: 'Car model',
				CAR_MODEL_YEAR: 'Car model year',
				CAR_COLOR: 'Car color',
				TICKET_FEES: 'Ticket fees',
			},
			COMPANY:{
				DRIVER_INFORMATION:'Driver\'s Information',
				MOBILE_PHONE:'Mobile number',
				FULL_NAME:'Full Name',
				COMPANY_INFORMATION:'Company\'s Information',
				COMPANY_NAME:'Comany\'s Name',
				COMPANY_BALANCE:'Company\'s Balance',
				CAR_INFORMATION:'Car Information',
				SELECT_CAR:'Select car',
				PLATE_NUMBER:'Plate Number',
				CAR_TYPE:'Car Type',
				CAR_NAME:'Car Name',
				BACK:'Back',
				PAY_CASH:'Pay Cash',
				COMPANY_PAY:'Company Pay',
				PAY_DRIVER_BALANCE:'Pay from driver balance',
				DRIVER_NAME:'Driver Name',
				TICKET_FEES: 'Ticket fees',
			},
		},
		DIALOG:{
			SUCCESS:'Success!',
			ERROR:'Error!',
			INFO:'Attention!',
			CONFIRM:'Confirm',
			SUCCESS_MESSAGE:'Operation completed successfully...',
			ERROR_MESSAGE:'Operation completed unsuccessfully...',
			CONFIRM_MESSAGE:'Are you sure?',
			INFO_MESSAGE:'Attention...',
			WAIT_MESSAGE:'Loading...',
			OK:'OK',
			CANCEL:'Cancel',
			REMOVE_CAR:'Remove from queue',
			COMPLETE_CAR:'Complete Request',
			CAR_OPTION:'Car Options',
		},
		DRIVER:{
			BALANCE:{
				TITLE: 'Balance',
				CURRENT_BALANCE: 'Current Balance',
				QUICK_ACTIONS: 'Quick Actions',
				TOP_UP_BALANCE: 'Top Up Balance',
				VIEW_TRANSACTIONS: 'View Transactions',
				RECENT_TRANSACTIONS: 'Recent Transactions',
				NO_TRANSACTIONS: 'No transactions found'
			},
			CHECKOUT:{
				TITLE: 'Balance Top-Up',
				PAYMENT_METHOD: 'Payment Method',
				AMOUNT: 'Amount (SAR)',
				FIRST_NAME: 'First Name',
				LAST_NAME: 'Last Name',
				EMAIL: 'Email',
				STREET_ADDRESS: 'Street Address',
				PROCEED_TO_PAYMENT: 'Proceed to Payment',
				PROCESSING: 'Processing...',
				LOADING_PAYMENT_WIDGET: 'Loading payment widget...',
				PROCESSING_PAYMENT: 'Processing payment...',
				REQUIRED_FIELD: 'This field is required',
				VALID_AMOUNT: 'Valid amount is required (minimum 1 SAR)',
				VALID_EMAIL: 'Valid email is required',
				WIDGET_ERROR: 'Failed to load payment widget. Please try again.',
				VERIFY_ERROR_TITLE: 'Payment verification failed',
				VERIFY_ERROR_DEFAULT: 'Payment could not be verified. Please try again or contact support.',
				TRY_AGAIN: 'Try again',
				BACK_TO_BALANCE: 'Back to balance'
			},
			TRANSACTIONS:{
				TITLE: 'Transaction History',
				TABLE: {
					DATE: 'Date',
					TYPE: 'Transaction Type',
					AMOUNT: 'Amount',
					DESCRIPTION: 'Description',
					ADDED_BY: 'Added By'
				},
				TYPES: {
					CASH_TOPUP: 'Cash Top-Up',
					CASH_WITHDRAWAL: 'Cash Withdrawal',
					ONLINE_TOPUP: 'Online Top-Up',
					BALANCE_PAYMENT: 'Balance Payment',
					BALANCE_REFUND: 'Balance Refund'
				},
				NO_TRANSACTIONS: 'No transactions found',
				LOADING: 'Loading transactions...'
			}
		},
		ADMIN: {
			DRIVER_BALANCE: {
				TITLE: 'Driver Balance Management',
				CURRENT_BALANCE: 'Current Balance',
				ACTIONS: 'Actions',
				ADD_CASH_TOPUP: 'Add Cash Top-Up',
				WITHDRAW_CASH: 'Withdraw Cash',
				VIEW_TRANSACTIONS: 'View Transactions',
				AMOUNT: 'Amount',
				ADD_TOPUP: 'Add Top-Up',
				WITHDRAW_AMOUNT: 'Withdraw Amount',
				AVAILABLE_BALANCE: 'Available Balance',
				ADDING_BALANCE: 'Adding Balance',
				ADDING_BALANCE_DESC: 'Enter the amount you want to add to the driver\'s balance.',
				WITHDRAWING_BALANCE: 'Withdrawing Balance',
				WITHDRAWING_BALANCE_DESC: 'Enter the amount to withdraw. Available balance:',
				ENTER_POSITIVE_AMOUNT: 'Enter amount to add (e.g., 100.00)',
				ENTER_WITHDRAWAL_AMOUNT: 'Enter amount to withdraw (e.g., 50.00)',
				VALIDATION: {
					AMOUNT_REQUIRED: 'Amount is required',
					ZERO_NOT_ALLOWED: 'Amount cannot be zero',
					MIN_AMOUNT: 'Minimum amount is 0.01 SAR',
					INSUFFICIENT_BALANCE: 'Insufficient balance. Available balance is less than the withdrawal amount'
				},
				MESSAGES: {
					TOPUP_SUCCESS: 'Successfully added {{amount}} SAR',
					WITHDRAWAL_SUCCESS: 'Successfully withdrew {{amount}} SAR',
					TOPUP_ERROR: 'Error occurred while adding balance',
					WITHDRAWAL_ERROR: 'Error occurred while withdrawing balance'
				},
				TRANSACTIONS: {
					TITLE: 'Driver Balance Transactions',
					TABLE: {
						DATE: 'Date',
						TYPE: 'Transaction Type',
						AMOUNT: 'Amount',
						DESCRIPTION: 'Description',
						ADDED_BY: 'Added By'
					},
					NO_TRANSACTIONS: 'No transactions found',
					LOADING: 'Loading transactions...'
				},
				TYPES: {
					CASH_TOPUP: 'Cash Top-Up',
					CASH_WITHDRAWAL: 'Cash Withdrawal',
					ONLINE_TOPUP: 'Online Top-Up',
					BALANCE_PAYMENT: 'Balance Payment',
					BALANCE_REFUND: 'Balance Refund'
				}
			}
		}
	}
};
